<template>
  <div class="report-slider">
    <div class="requirements-nav"></div>
    <div class="button-container">
      <DirectionButton
        :props-handle-click="prev"
        class="report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev"
        :direction="'prev'"
        :icon="'arrow-left--white'"
      />
      <DirectionButton
        :props-handle-click="next"
        class="report-slider__pagination--next report-slider__pagination-top--next swiper-button-next"
        :direction="'next'"
        :icon="'arrow-right--white'"
      />
    </div>

    <swiper ref="reportSlider" :options="optionsPaginationTop" class="">
      <swiper-slide
        v-for="(item, index) in productsAndServicesData"
        :key="index"
      >
        <div class="requirements-row">
          <h2 class="licence-title">{{ item.licenseName }}</h2>
          <RequirementsReportList
            :jurisdiction="item.jid"
            :requirements="item.categories"
            :reports="true"
            :full="false"
          />
        </div>
      </swiper-slide>
    </swiper>

    <!-- <Accordion
      v-for="(jurisdiction, index) in productsAndServicesData"
      :id="index"
      :key="index"
      :iso="findIso(jurisdiction.name)"
      :full="true"
      :dir-button="true"
      :title="jurisdiction.licenseName"
      :no-border="true"
      size="accordion-large"
      :pid="index"
      level="jurisdiction"
    >
    <RequirementsList
        :jurisdiction="jurisdiction.jid"
        :requirements="jurisdiction.categories"
        :reports="true"
      />
    </Accordion> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "ReportRequirement",
  components: {
    // Accordion: () => import("../elements/Accordion"),
    RequirementsReportList: () => import("../elements/RequirementReportList"),
    DirectionButton: () => import("@/components/elements/DirectionButton"),
    Swiper,
    SwiperSlide,
  },
  props: {
    productsAndServices: {
      type: Array,
      default: () => [],
    },
    jurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenJurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenProductsAndServices: {
      type: Array,
      default: () => [],
    },
    chosenLicenses: {
      type: Array,
      default: () => [],
    },
    chosenRequirements: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      optionsPaginationTop: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 45,
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
        },
        navigation: {
          nextEl: ".report-slider__pagination-top--next",
          prevEl: ".report-slider__pagination-top--prev",
        },
      },
    };
  },
  computed: {
    ...mapState("ReportBuilder", ["productsAndServicesData"]),
    ...mapState("Global", ["isoCodes"]),
  },

  created() {
    let queryParams = this.chosenLicenses.map((s) => "filter[lid][]=" + s.id);
    queryParams = queryParams.concat(
      this.chosenRequirements.map((j) => "filter[rcid][]=" + j)
    );
    this.$store
      .dispatch("ReportBuilder/getViewData", {
        url:
          "/report-builder/requirement-data-by-license?" +
          queryParams.join("&"),
      })
      .then(({ data }) => {
        this.$store.commit("ReportBuilder/setData", {
          label: "productsAndServicesData",
          data,
        });
        const links = [];
        this.productsAndServicesData.forEach((j) => {
          j.related_guides.forEach((r) => {
            if (!links.some((l) => l.title === r.title)) {
              links.push(r);
            }
          });
        });
        this.$emit("updateSidebarLinks", links);
      })
      .catch((error) => console.error("ERROR:", error));
  },
  methods: {
    goToPrev() {
      this.$refs.productsSlider.prev();
    },
    goToNext() {
      this.$refs.productsSlider.next();
    },
    next() {
      const slider = "reportSlider";
      this.$refs[slider].$swiper.slideNext();
    },
    prev() {
      const slider = "reportSlider";
      this.$refs[slider].$swiper.slidePrev();
    },
    findIso(countryName) {
      const isoCode = this.isoCodes.find((el) => el.name === countryName);
      if (isoCode) return isoCode["alpha-2"];

      return null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.report-slider {
  overflow: hidden;
  margin: 1rem 0 0;

  .requirements-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 10px;
  }
  .button-container {
    display: flex;
    justify-content: space-between;
  }
  .report-slider__pagination--prev,
  .report-slider__pagination--next {
    position: relative;
    align-content: right;
  }

  .report-slider__pagination--next {
    background: $accentBlue;

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }

  .report-slider__pagination--prev {
    left: auto;
    background: $accentBlue;

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }
}
.country__icon {
  height: 3rem;
  width: 3rem;
  display: inline-block;
  padding-right: 1rem;

  img {
    width: 100%;
  }
}

.el-tabs {
  padding-left: 2rem;
}

.licence-title {
  font-size: 2rem;
  font-weight: 700;
}
</style>
